var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"feedSearch"}},[_c('div',{staticClass:"feedSearch_header"},[_c('search')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }